var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-wrap"},[_c('div',{staticClass:"index-nav"},[_c('h1',[_vm._v("智能公共法律服务系统（民法典婚姻家庭编版）")]),_vm._v(" "),_c('p',[_vm._v("北京大学法律人工智能实验室")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.goToQuestionsPage}},[_vm._v("立即咨询")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-646a3a30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Index.vue
// module id = null
// module chunks = 